import { observer } from 'mobx-react-lite';
import { ModalOption } from '../../../stores/modalStore';
import { Modal } from './Modal';

const CustomModal = observer(({ modalId, option }: { modalId: string; option: ModalOption }) => {
    const { custom } = option;

    if (!custom) {
        return null;
    }

    return (
        <Modal.Dialog modalId={modalId}>
            <Modal.BodyScroll>
                <div>{custom.renderComponent({ modalId })}</div>
            </Modal.BodyScroll>
        </Modal.Dialog>
    );
});

export default CustomModal;
